<template>
  <div class="col-xl-5 col-lg-12 d-flex flex-column">
    <div class="card payment-card">
      <div class="payment-info">
        <div class="payment-content">
          <p>Your Wallet Balance</p>
          <h2>$4,544</h2>
        </div>
        <div class="payment-btn">
          <a
            href="javascript:void(0);"
            class="btn"
            data-bs-toggle="modal"
            data-bs-target="#add-payment"
            >Add Payment</a
          >
        </div>
      </div>
    </div>
    <div class="card dashboard-card upcoming-card">
      <div class="card-header card-header-info">
        <div class="card-header-inner">
          <h4>Upcoming Appointment</h4>
          <p>Manage all your upcoming court bookings.</p>
        </div>
        <div class="card-header-btns">
          <nav>
            <div class="nav nav-tabs" role="tablist">
              <button
                class="nav-link active"
                id="nav-Appointment-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-Appointment"
                type="button"
                role="tab"
                aria-controls="nav-Appointment"
                aria-selected="true"
              >
                Court
              </button>
              <button
                class="nav-link"
                id="nav-AppointmentCoaching-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-AppointmentCoaching"
                type="button"
                role="tab"
                aria-controls="nav-AppointmentCoaching"
                aria-selected="false"
              >
                Coaching
              </button>
            </div>
          </nav>
        </div>
      </div>
      <div class="tab-content">
        <div
          class="tab-pane fade show active"
          id="nav-Appointment"
          role="tabpanel"
          aria-labelledby="nav-Appointment-tab"
          tabindex="0"
        >
          <div class="table-responsive dashboard-table-responsive">
            <table class="table dashboard-card-table">
              <tbody>
                <tr>
                  <td>
                    <div class="academy-info academy-info">
                      <router-link to="user-bookings" class="academy-img">
                        <img src="@/assets/img/booking/booking-02.jpg" alt="Booking" />
                      </router-link>
                      <div class="academy-content">
                        <h6>
                          <a data-bs-toggle="modal" data-bs-target="#upcoming-court"
                            >Leap Sports Academy</a
                          >
                        </h6>
                        <ul>
                          <li>Court 1</li>
                          <li><i class="feather-clock"></i> 06:00 PM to 08:00 PM</li>
                        </ul>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="dropdown dropdown-action">
                      <a
                        href="javascript:void(0);"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="fas fa-ellipsis"></i
                      ></a>
                      <div class="dropdown-menu dropdown-menu-end">
                        <a class="dropdown-item" href="javascript:void(0);">
                          <i class="feather-x-circle"></i> Cancel
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="nav-AppointmentCoaching"
          role="tabpanel"
          aria-labelledby="nav-AppointmentCoaching-tab"
          tabindex="0"
        >
          <div class="table-responsive dashboard-table-responsive">
            <table class="table dashboard-card-table">
              <tbody>
                <tr>
                  <td>
                    <div class="academy-info academy-info">
                      <router-link to="user-bookings" class="academy-img">
                        <img src="@/assets/img/featured/featured-05.jpg" alt="Booking" />
                      </router-link>
                      <div class="academy-content">
                        <h6>
                          <a data-bs-toggle="modal" data-bs-target="#upcoming-coach"
                            >Kevin Anderson</a
                          >
                        </h6>
                        <ul>
                          <li>Single Lesson</li>
                          <li><i class="feather-clock"></i> 06:00 PM to 08:00 PM</li>
                        </ul>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="dropdown dropdown-action">
                      <a
                        href="javascript:void(0);"
                        class="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="fas fa-ellipsis"></i
                      ></a>
                      <div class="dropdown-menu dropdown-menu-end">
                        <a class="dropdown-item" href="javascript:void(0);">
                          <i class="feather-x-circle"></i> Cancel
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card dashboard-card academy-card">
      <div class="card-header card-header-info">
        <div class="card-header-inner">
          <h4>My Favourites</h4>
          <p>My favourite court lists</p>
        </div>
        <div class="card-header-btns">
          <nav>
            <div class="nav nav-tabs" role="tablist">
              <button
                class="nav-link active"
                id="nav-Favourites-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-Favourites"
                type="button"
                role="tab"
                aria-controls="nav-Favourites"
                aria-selected="true"
              >
                Court
              </button>
              <button
                class="nav-link"
                id="nav-FavouritesCoaching-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-FavouritesCoaching"
                type="button"
                role="tab"
                aria-controls="nav-FavouritesCoaching"
                aria-selected="false"
              >
                Coaching
              </button>
            </div>
          </nav>
        </div>
      </div>
      <div class="tab-content">
        <div
          class="tab-pane fade show active"
          id="nav-Favourites"
          role="tabpanel"
          aria-labelledby="nav-Favourites-tab"
          tabindex="0"
        >
          <div class="table-responsive dashboard-table-responsive">
            <table class="table dashboard-card-table">
              <tbody>
                <tr v-for="record in Fav_Court" :key="record.id">
                  <td>
                    <div class="academy-info academy-info">
                      <router-link to="/user/user-bookings" class="academy-img">
                        <img
                          :src="require(`@/assets/img/booking/${record.Image}`)"
                          alt="Booking"
                        />
                      </router-link>
                      <div class="academy-content">
                        <h6>
                          <router-link to="/user/user-bookings">{{
                            record.Image
                          }}</router-link>
                        </h6>
                        <p>{{ record.Booking }}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="academy-icon">
                      <router-link to="/user/user-bookings">
                        <i class="feather-chevron-right"></i>
                      </router-link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="nav-FavouritesCoaching"
          role="tabpanel"
          aria-labelledby="nav-FavouritesCoaching-tab"
          tabindex="0"
        >
          <div class="table-responsive dashboard-table-responsive">
            <table class="table dashboard-card-table">
              <tbody>
                <tr v-for="record in Fav_Coaching" :key="record.id">
                  <td>
                    <div class="academy-info academy-info">
                      <router-link to="/user/user-bookings" class="academy-img">
                        <img
                          :src="require(`@/assets/img/featured/${record.Image}`)"
                          alt="Booking"
                        />
                      </router-link>
                      <div class="academy-content">
                        <h6>
                          <router-link to="/user/user-bookings">{{
                            record.Name
                          }}</router-link>
                        </h6>
                        <p>{{ record.Booking }}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="academy-icon">
                      <router-link to="/user/user-bookings">
                        <i class="feather-chevron-right"></i>
                      </router-link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fav_Court from "@/assets/json/fav-court.json";
import Fav_Coaching from "@/assets/json/fav-coaching.json";
export default {
  data() {
    return {
      Fav_Coaching: Fav_Coaching,
      Fav_Court: Fav_Court,
    };
  },
};
</script>
